import { GoogleOAuthProvider } from "@react-oauth/google";
import React from 'react';
import { 
  Box, 
  Grid,
  Stack
} from '@mui/material';
import Pilot from "../Components/Pilot/Pilot.jsx";
import Brent from "../Components/Brent/Brent.jsx";
import ResourcesSidebar from "../Components/Resources/ResourcesSidebar.jsx";

const Resources = () => {
  return (
    <Box sx={{ 
      p: 3, 
      maxWidth: 1200, 
      margin: '0 auto',
      height: 'calc(100vh - 64px)', // fill viewport below fixed header
      overflow: 'auto',
      boxSizing: 'border-box',
    }}>
      {/* <Typography variant="h4" sx={{ mb: 3, color: '#3598b7', fontWeight: 600 }}>
        Company Resources
      </Typography> */}

      <Grid container spacing={3} alignItems="flex-start">
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <Brent />
            <GoogleOAuthProvider clientId="323150633316-m43g3oj3qkcvlkookie1qji41o2oat0b.apps.googleusercontent.com">
              <Pilot />
            </GoogleOAuthProvider>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <ResourcesSidebar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resources;

